import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListDoctoralDisciplines from "./List";
import CreateDoctoralDisciplines from "./Create";
import EditDoctoralDisciplines from "./Edit";
import ShowDoctoralDisciplines from "./Show";

export const resources = {
  isMenu: true,
  icon: <AutoStoriesIcon />,
  name: `${DoctoralServicePath}doctoral-disciplines`,
  title: "Дисциплини",
  list: <ListDoctoralDisciplines />,
  create: <CreateDoctoralDisciplines />,
  createPermission: permissions.canCreateDoctoralDisciplines,
  edit: <EditDoctoralDisciplines />,
  editPermission: permissions.canUpdateDoctoralDisciplines,
  show: <ShowDoctoralDisciplines />,
  permission: permissions.canPreviewDoctoralDisciplines,
};
